import { render, staticRenderFns } from "./AppLauncherHeaderAgentPopup.vue?vue&type=template&id=985a730a&scoped=true"
import script from "./AppLauncherHeaderAgentPopup.vue?vue&type=script&lang=ts"
export * from "./AppLauncherHeaderAgentPopup.vue?vue&type=script&lang=ts"
import style0 from "./AppLauncherHeaderAgentPopup.vue?vue&type=style&index=0&id=985a730a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.31_css-loader@7.1.4_webpack@5.105.4__ejs@3.1.10_hand_ylukk2m4i5f72bin4t3vwj3wvq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985a730a",
  null
  
)

export default component.exports